module.exports = __webpack_public_path__ + "img/2P40.942a9cda.png";